import * as React from 'react';
import { TickMarkOutlined } from '@duxton-web/icons';
import { Typography } from '@duxton-web/ui';
import { ColumnProps } from '@duxton-web/ui/lib/table';
import { snakeCase, startCase } from 'lodash';

import { Policy, TechFamily, TFRole } from '@/lib/App';

const { Text } = Typography;

export interface ColumnType {
  admin: boolean;
  default: boolean;
  editor: boolean;
  experiment_council: boolean;
  experiment_moderator: boolean;
  moderator: boolean;
  rollout_moderator: boolean;
  techFamily: string;
}

export const getDataSource = (
  userTFRoles: TFRole[],
  policies: Policy[],
  techFamilies: TechFamily[],
  isAdmin: boolean,
): ColumnType[] => {
  const data = techFamilies
    .map((techFamily) => {
      let row = {};
      let hasRole = false;
      row['techFamily'] = techFamily.prefix;
      policies.map((policy) => {
        row[policy.policyName] = false;
      });

      userTFRoles.map((userTFRole) => {
        if (userTFRole.tf == techFamily.prefix) {
          row[snakeCase(userTFRole.role)] = true;
          hasRole = true;
        }
      });

      if (isAdmin) {
        row['admin'] = true;
        hasRole = true;
      }

      if (hasRole) {
        return row;
      }
    })
    .filter((row) => row != undefined);
  return data as ColumnType[];
};

export const getColumns = (policies: Policy[]): ColumnProps<ColumnType>[] => {
  const columns: ColumnProps<ColumnType>[] = [
    {
      title: 'Tech Family',
      dataIndex: 'techFamily',
      key: 'techFamily',
      render: (text: string) => {
        return <Text strong>{text}</Text>;
      },
    },
  ];

  policies.map((policy) => {
    const column = {};
    column['title'] = startCase(policy.policyName);
    column['dataIndex'] = policy.policyName;
    column['render'] = (text: boolean) => {
      const hasAccess = text === true ? true : false;
      return hasAccess ? (
        <TickMarkOutlined style={{ fontSize: '30px', color: 'green' }} />
      ) : (
        <span>&mdash;</span>
      );
    };
    columns.push(column);
  });
  return columns;
};
